<table
  aria-label="Data"
  i18n-aria-label
  cdkDropListGroup
  [cdkDropListGroupDisabled]="!resizableColumns"
  mat-table
  [ngClass]="{ 'mtna-ghost-table': ghost, 'resizable-columns': resizableColumns, 'resize-active': _resizingColumn, sortable: enableSort }"
  [dataSource]="dataSet?.records || []"
>
  <ng-container
    *ngFor="let variable of _editableColumns?.CHECK; trackBy: _trackByCr"
    [matColumnDef]="$any(variable.uri || variable.id)"
    [sticky]="!!variable.uri ? _lockedColumns[variable.uri] : false"
  >
    <th
      mat-header-cell
      *matHeaderCellDef
      class="rds-c-select-table-check-cell mtna-ghostable-cell"
      [class.rds-c-select-table-last-locked-column]="_lastLockedVariable === variable.uri"
    >
      {{ variable.name }}
      <rds-c-select-table-decorators
        [appliedFilters]="_appliedFilters"
        [keyColumns]="_keyColumns"
        [toggledAreSelected]="toggledAreSelected"
        [toggledColumns]="_toggledColumns"
        [uri]="variable.uri"
      ></rds-c-select-table-decorators>
    </th>
    <td
      mat-cell
      *matCellDef="let record"
      class="rds-c-select-table-check-cell mtna-ghostable-cell"
      [ngClass]="{
        'rds-c-select-table-last-locked-column': _lastLockedVariable === variable.uri,
        'rds-c-select-table-locked-column': !!variable.uri ? _lockedColumns[variable.uri] : false
      }"
    >
      <mat-checkbox
        (change)="handleCheckChange($event, record, variable)"
        [checked]="!!(codeDisplayType | rdsGetRecordValue: record:variable)"
      >
      </mat-checkbox>
    </td>
  </ng-container>
  <ng-container
    *ngFor="let variable of _readOnlyVariables; trackBy: _trackByCr"
    [matColumnDef]="$any(variable.uri)"
    [sticky]="!!variable.uri ? _lockedColumns[variable.uri] : false"
  >
    <th
      mat-header-cell
      *matHeaderCellDef
      [attr.aria-sort]="sortedColumns.length | getAriaSort: variable.uri:sortedColumns"
      [matTooltip]="$any(variable.label)"
      [matTooltipDisabled]="!variable.label || enableSort"
      matTooltipShowDelay="500"
      matTooltipPosition="below"
      class="rds-c-can-inspect-cell mtna-ghostable-cell mtna-sortable-header"
      [ngClass]="{
        'rds-c-select-table-last-locked-column': _lastLockedVariable === variable.uri,
        inspected: variable.uri === inspectedVariable?.uri,
        resizing: _resizingColumn && _currentResizeId === variable.uri,
        numeric: variable | rdsIsRecordValueNumber
      }"
      [ngStyle]="{
        'width.px': resizableColumns && variable.uri ? _columnWidth[variable.uri] : null,
        'min-width.px': resizableColumns && variable.uri ? _columnWidth[variable.uri] : null,
        'max-width.px': resizableColumns && variable.uri ? _columnWidth[variable.uri] : null
      }"
    >
      <mtna-header-sort
        contentButtonLabel="Inspect {{ variable.label || variable.name || variable.id }}"
        i18n-contentButtonLabel
        sortActionDescription="Sort by {{ variable.label || variable.name || variable.id }}"
        i18n-sortActionDescription
        [contentButtonDisabled]="inspectDisabled"
        [contentButtonTooltip]="$any(variable.label)"
        [direction]="sortedColumns.length | getSortDirection: variable.id!:sortedColumns"
        [headerTitle]="variable.name"
        [selectable]="selectableHeaders"
        [sortButtonTooltip]="variable.classificationUri ? _headerSortButtonTooltip : null"
        [sortButtonPosition]="(variable | rdsIsRecordValueNumber) ? 'before' : 'after'"
        (selected)="handleInspectVariable(variable)"
        (sort)="handleSortColumn($event, variable.id!, variable.label || variable.name || variable.id)"
      >
      </mtna-header-sort>
      <span
        *ngIf="resizableColumns"
        (dblclick)="_onAutoResize($event, variable.uri)"
        class="drag-handle"
        (mousedown)="_onResizeColumn($event, variable.uri)"
      ></span>
      <rds-c-select-table-decorators
        [appliedFilters]="_appliedFilters"
        [keyColumns]="_keyColumns"
        [toggledAreSelected]="toggledAreSelected"
        [toggledColumns]="_toggledColumns"
        [uri]="variable.uri"
      ></rds-c-select-table-decorators>
    </th>
    <td
      mat-cell
      *matCellDef="let record"
      [ngClass]="{
        'rds-c-select-table-last-locked-column': _lastLockedVariable === variable.uri,
        'rds-c-select-table-locked-column': variable.uri ? _lockedColumns[variable.uri] : false,
        numeric: variable | rdsIsRecordValueNumber
      }"
      [ngStyle]="{
        'width.px': resizableColumns && variable.uri ? _columnWidth[variable.uri] : null,
        'min-width.px': resizableColumns && variable.uri ? _columnWidth[variable.uri] : null,
        'max-width.px': resizableColumns && variable.uri ? _columnWidth[variable.uri] : null
      }"
      class="mtna-ghostable-cell"
    >
      {{ codeDisplayType | rdsGetRecordValue: record:variable }}
    </td>
  </ng-container>

  <tr [@rowsAnimation] mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr [@rowsAnimation] mat-row *matRowDef="let record; columns: displayedColumns"></tr>
</table>
